<template>
  <div class="ui top-bar">
    <a :href="this.link" target="_blank">
      <div class="container"><slot></slot></div>
    </a>
  </div>
</template>

<script>
export default {
  props: ['link']
};
</script>

<style>
.show-top-bar {
  margin-top: 46px;
}
</style>

<style scoped>
.ui.top-bar {
  z-index: 999;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0.4rem;
  background: #000;
}
.ui.top-bar > a {
  font-size: 1rem;
  color: hsla(0, 0%, 100%, 0.87);
  text-align: center;
}
</style>
